import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  EditButton,
  DeleteButton,
  FunctionField,
} from 'react-admin';

export const CollectionList = () => (
  <List>
    <Datagrid>
      <TextField source="name" />
      <TextField source="slug" />
      <FunctionField
        label="Изображение"
        render={(record: any) => {
          if (record.image) {
            const thumbnail = record.image.thumbnails?.find((t: any) => t.variant === 'thumbnail');
            const imageUrl = thumbnail?.url || record.image.url;
            return (
              <img 
                src={imageUrl} 
                alt={record.name} 
                style={{ width: 50, height: 50, objectFit: 'cover' }} 
              />
            );
          }
          return 'Нет изображения';
        }}
      />
      <NumberField source="sortOrder" label="Порядок" />
      <BooleanField source="isActive" label="Активна" />
      <FunctionField 
        label="Товаров" 
        render={(record: any) => record._count?.products || 0} 
      />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
